var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"text-lowercase text-caption font-weight-medium",attrs:{"color":_vm.requerido ? 'success' : _vm.color,"outlined":_vm.outlined,"small":!_vm.xSmall,"x-small":_vm.xSmall,"label":"","dark":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }